import classnames from 'classnames';
import UserAvatar from './UserAvatar';
import UserActivityStatus from './UserActivityStatus';

type TUserAvatarProps = {
  id?: number;
  image?: string;
  initials?: string;
  icon?: string;
  tooltip?: string;
}

type TUserActivityStatusProps = {
  id?: number;
  status?: number;
  lastSeen?: number;
  autoUpdate?: boolean;
  skipSubscription?: boolean;
  isSigner?: boolean;
  showTooltip?: boolean;
}

type TUserAvatarWithActivityStatusProps = {
  size: string;
  avatar?: TUserAvatarProps;
  activityStatus?: TUserActivityStatusProps;
  className?: string;
}

const UserAvatarWithActivityStatus = ({ size, avatar, activityStatus, className }: TUserAvatarWithActivityStatusProps) => {

  return <div className={classnames('user-avatar-with-activity-status', `user-avatar-with-activity-status-${size}`, className)}>
    <UserAvatar {...avatar} size={size} />
    <UserActivityStatus {...activityStatus} size={size} hideText={true} />
  </div>
}

export default UserAvatarWithActivityStatus;

